import PropTypes from 'prop-types';
import {lazy} from 'react';
import {connect} from 'react-redux';
import {isInPaypalExperiment} from '../../../selectors/ExperimentSelectors';
import getIsUsingExpressCheckout from '../../../selectors/ExpressSelectors/getIsUsingExpressCheckout';
import getExpressPaymentMethods from '../../../selectors/PaymentOptionSelectors/getExpressPaymentMethodsSelector';
import {isZeroValueOrder} from '../../../selectors/selectors';
import GenericFallbackSuspense from '../../ui/GenericFallback/GenericFallbackSuspense';

const ExpressCheckout = lazy(() => (
  import('./ExpressCheckout'/* webpackChunkName: 'ExpressCheckout' */)
));

export function ExpressCheckoutLazyLoaderPresentational(props) {
  if (
    !props.hasExpressPaymentMethods
    || props.usingExpressCheckout
    || !props.isInPaypalExperiment
    || props.zeroOrderValue
  ) return null;
  
  return (
    <GenericFallbackSuspense>
      <ExpressCheckout />
    </GenericFallbackSuspense>
  );
}

const mapStateToProps = state => ({
  hasExpressPaymentMethods: getExpressPaymentMethods(state).length > 0,
  usingExpressCheckout: getIsUsingExpressCheckout(state),
  isInPaypalExperiment: isInPaypalExperiment(state),
  zeroOrderValue: isZeroValueOrder(state),
});

ExpressCheckoutLazyLoaderPresentational.propTypes = {
  hasExpressPaymentMethods: PropTypes.bool.isRequired,
  usingExpressCheckout: PropTypes.bool.isRequired,
  isInPaypalExperiment: PropTypes.bool.isRequired,
  zeroOrderValue: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(ExpressCheckoutLazyLoaderPresentational);
